import { Component, EventEmitter, ViewEncapsulation, Input, Output } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';

import { DocumentCodeWithIdFilterType,
	DocumentSuggestiveListFilterWithId, DynamicDatacenterFilter } from '../../../../models/datacenter-filters';
import { pageTransitions } from '../../../../animations/page-transitions';
import { DatacenterFilterApiService } from '../../../../services/datacenter-filter-api.service';

import { DocumentSuggestiveItemCodeFilterComponent } from './doc-suggestive-item-code-filter.component';

@Component({
	selector: 'copo-doc-suggestive-list-id-filter',
	templateUrl: './doc-suggestive-list-id-filter.component.html',
	styleUrl: './doc-suggestive-list-id-filter.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	providers: [DatacenterFilterApiService],
	imports: [NgIf, NgFor, MatIconModule, MatRippleModule, DocumentSuggestiveItemCodeFilterComponent]
})
export class DocumentSuggestiveListIdFilterComponent implements
DynamicDatacenterFilter<DocumentSuggestiveListFilterWithId> {
	@Input() filter?: DocumentSuggestiveListFilterWithId;
	@Output() readonly removeFilter = new EventEmitter<void>();
	@Input() isDefaultFilter?: boolean;

	removeValue(item: DocumentCodeWithIdFilterType) {
		if (!this.filter) {
			return;
		}
		this.filter.getValues().splice(this.filter.getValues().findIndex(search => search.id === item.id), 1);
		if (!this.filter.valueSize()) {
			this.removeFilter.emit();
		}
	}

	trackByFunc(index: number) {
		return index;
	}

	getPreparedFilterValues() {
		if (this.filter) {
			return {
				id: this.filter.filterId,
				values: this.filter.getValues()
					.filter(filterValue => !filterValue.code)
			};
		}
		return undefined;
	}
}
